/*
 * G36 · Releasit COD button on the cart page and in the cart drawer.
 * Loaded on every page (layout/theme.liquid): when the cart is empty on load, Releasit mounts
 * its button inside the empty drawer; Horizon's morph removes it when the first item is added,
 * and the swap below puts it back into the drawer's #cart-wrapper (snippets/cart-summary.liquid).
 *
 * snippets/cart-summary.liquid renders #cart-wrapper with data-skip-subtree-update, so Horizon's
 * morph keeps Releasit's button alive on remove / quantity changes. The one case morph can't
 * cover is when the cart empties (the summary, and the wrapper with it, is removed) and then
 * fills again without a reload: the server renders a fresh, empty #cart-wrapper while Releasit's
 * React portal still points at the old, detached one. Here we keep a reference to the wrapper
 * that holds the button and swap it back in. React listens on the portal container itself, so
 * the moved node keeps working.
 */
(() => {
  if (window.__g36RsiCart) return;
  window.__g36RsiCart = true;

  const BUTTON = '#rsi_buy_now_button';
  /** @type {HTMLElement | null} */
  let live = null;
  let queued = false;

  const sync = () => {
    queued = false;
    const current = document.getElementById('cart-wrapper');
    if (current && current.querySelector(BUTTON)) {
      live = current;
      return;
    }
    if (live && !live.isConnected && current && current !== live) {
      current.replaceWith(live);
    }
  };

  const start = () => {
    sync();
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      queueMicrotask(sync);
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  /*
   * G36 · "Comprar ahora" cargando: Releasit tarda 1-3 s en abrir el formulario (en celular,
   * más). Al tocarlo, el botón muestra un giro hasta que el formulario se abre (máx. 10 s).
   * Si el clic lo frenó la talla obligatoria (g36-ui.js), no llega aquí: ese freno corta el
   * evento en captura.
   */
  /** @type {HTMLElement | null} */
  let loading = null;
  let timer = 0;

  const stopLoading = () => {
    clearTimeout(timer);
    loading?.removeAttribute('data-g36-loading');
    loading = null;
  };

  // En captura: Releasit corta la propagación de su clic y no llegaría a document
  window.addEventListener(
    'click',
    (event) => {
      const button = event.target instanceof Element ? event.target.closest(BUTTON) : null;
      if (!(button instanceof HTMLElement) || button.closest('#rsi_form_wrapper')) return;
      if (document.getElementById('rsi_form_wrapper')?.hasAttribute('open')) return;
      // Si falta la talla, g36-ui.js frena este clic y pide talla: sin giro
      const sizePending =
        document.documentElement.hasAttribute('data-g36-size-pending') &&
        !button.closest('#quick-view-modal, .g36-fav, #cart-drawer');
      if (sizePending) return;
      requestAnimationFrame(() => {
        if (!button.isConnected) return;
        if (document.getElementById('rsi_form_wrapper')?.hasAttribute('open')) return;
        stopLoading();
        loading = button;
        button.setAttribute('data-g36-loading', '');
        timer = window.setTimeout(stopLoading, 10000);
      });
    },
    true
  );

  window.addEventListener('pageshow', stopLoading);

  new MutationObserver(() => {
    if (loading && document.getElementById('rsi_form_wrapper')?.hasAttribute('open')) stopLoading();
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });
})();
